module.exports = __webpack_public_path__ + "img/iraq.5a151c72.png";